import { useEffect, useRef, useState } from "react";
import StarRating from "./StarRating"
import { useLocalStorage } from "./useLocalStorage";
import { useKey } from "./useKey";

// const tempMovieData = [
// 	{
// 		imdbID: "tt1375666",
// 		Title: "Inception",
// 		Year: "2010",
// 		Poster:
// 			"https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg",
// 	},
// 	{
// 		imdbID: "tt0133093",
// 		Title: "The Matrix",
// 		Year: "1999",
// 		Poster:
// 			"https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
// 	},
// 	{
// 		imdbID: "tt6751668",
// 		Title: "Parasite",
// 		Year: "2019",
// 		Poster:
// 			"https://m.media-amazon.com/images/M/MV5BYWZjMjk3ZTItODQ2ZC00NTY5LWE0ZDYtZTI3MjcwN2Q5NTVkXkEyXkFqcGdeQXVyODk4OTc3MTY@._V1_SX300.jpg",
// 	},
// ];

// const tempWatchedData = [
// 	{
// 		imdbID: "tt1375666",
// 		Title: "Inception",
// 		Year: "2010",
// 		Poster:
// 			"https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg",
// 		runtime: 148,
// 		imdbRating: 8.8,
// 		userRating: 10,
// 	},
// 	{
// 		imdbID: "tt0088763",
// 		Title: "Back to the Future",
// 		Year: "1985",
// 		Poster:
// 			"https://m.media-amazon.com/images/M/MV5BZmU0M2Y1OGUtZjIxNi00ZjBkLTg1MjgtOWIyNThiZWIwYjRiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_SX300.jpg",
// 		runtime: 116,
// 		imdbRating: 8.5,
// 		userRating: 9,
// 	},
// ];

const average = (arr) =>
	arr.reduce((acc, cur, i, arr) => acc + cur / arr.length, 0);

const KEY = '33ca1bd5'

//////////////////////////////////////////////////

export default function App() {
	const [movies, setMovies] = useState([]);
	const [loading, setisLoading] = useState(false)
	const [error, setError] = useState("")
	const [query, setQuery] = useState("");
	const [selectedId, setSelectedId] = useState(null)

	const [watched, setWatched] = useLocalStorage([], "watched")


	function handleSelectMovie(id) {
		setSelectedId(selectedId => id === selectedId ? null : id)
	}

	function handleCloseMovie() {
		setSelectedId(null)
	}

	function handleAddWatched(movie) {
		setWatched(watched => [...watched, movie])
	}

	function handleDeleteWatched(id) {
		setWatched(watched => watched.filter(movie => movie.imdbID !== id))
	}




	useEffect(function () {
		const controller = new AbortController()

		async function fetchMovies() {
			try {
				setisLoading(true)
				setError("")
				const res = await fetch(`https://www.omdbapi.com/?apikey=${KEY}&s=${query}`,
					{ signal: controller.signal })

				if (!res.ok) {
					throw new Error("Something went wrong")
				}

				const data = await res.json()
				if (data.Response === "False") throw new Error("Movie Not Found")

				setMovies(data.Search)
				setError("")
				// console.log(data)
				// console.log(data.Search)
			}
			catch (err) {
				// console.log(err.message)
				setError(err.message)
			}
			finally {
				setisLoading(false)

			}
		}

		if (query.length < 3) {
			setMovies([])
			setError("")
			return
		}
		handleCloseMovie()
		fetchMovies()

		return function () {
			controller.abort()
		}

	}, [query])

	return (
		<>
			<Navbar>
				<Logo />
				<Search query={query} setQuery={setQuery} />
				<NumResult movies={movies} />
			</Navbar>

			<Main>

				<Box >
					{/* {loading ? <Load /> : <MovieList movies={movies} />} */}
					{loading && <Load />}
					{!loading && !error && <MovieList movies={movies} onSelectMovie={handleSelectMovie} />}
					{error && <ErrorMessage message={error} />}

				</Box>

				<Box>
					{
						selectedId ? <MovieDetails selectedId={selectedId} onCloseMovie={handleCloseMovie} onAddWatched={handleAddWatched} watched={watched} /> :
							<>
								<WatchedSummary watched={watched} />
								<WatchedMoviesList watched={watched} onDeleteWatched={handleDeleteWatched} />
							</>
					}
				</Box>

				{/* ##### Alternative Way using Element ###### */}
				{/* <Box element={<MovieList movies={movies} />} />
				<Box element={
					<>
						<WatchedSummary watched={watched} />
						<WatchedMoviesList watched={watched} />
					</>}
				/> */}

			</Main>
		</>
	);
}


function Navbar({ children }) {
	return (
		<nav className="nav-bar">
			{children}
		</nav>
	)
}

function Logo() {
	return <div className="logo">
		<span role="img">🎬</span>
		<h1>CineGrade</h1>
	</div>
}

function Search({ query, setQuery }) {

	const inputEl = useRef(null)

	useKey('Enter', function () {
		if (document.activeElement === inputEl.current) return
		inputEl.current.focus()
		setQuery("")
	})



	return (
		<input
			className="search"
			type="text"
			placeholder="Search movies..."
			value={query}
			onChange={(e) => setQuery(e.target.value)}
			ref={inputEl}
		/>
	)
}

function Load() {
	return <p className="loader">Loading...</p>
}

function ErrorMessage({ message }) {
	return <p className="error"><span>⛔</span>{message}</p>
}

function NumResult({ movies }) {
	return (
		<p className="num-results">
			Found <strong>{movies.length}</strong> results
		</p>
	)
}

function Main({ children }) {
	return (
		<main className="main">
			{children}
		</main>
	)
}

function Box({ children }) {

	const [isOpen, setIsOpen] = useState(true);

	return (
		<div className="box">
			<button
				className="btn-toggle"
				onClick={() => setIsOpen((open) => !open)}
			>
				{isOpen ? "–" : "+"}
			</button>
			{isOpen && children}
		</div>
	)
}

// ######It is a old code and it is simplified in the above component
/*
function WatchedBox() {
	const [isOpen2, setIsOpen2] = useState(true);

	return (
		<div className="box">
			<button
				className="btn-toggle"
				onClick={() => setIsOpen2((open) => !open)}
			>
				{isOpen2 ? "–" : "+"}
			</button>
			{isOpen2 && (
				<>
					<WatchedSummary watched={watched} />
					<WatchedMoviesList watched={watched} />
				</>
			)}
		</div>
	)
}
*/


function MovieList({ movies, onSelectMovie }) {

	return (
		<ul className="list list-movies">
			{movies?.map((movie) => (
				<Movie movie={movie} key={movie.imdbID} onSelectMovie={onSelectMovie} />
			))}
		</ul>
	)
}

function Movie({ movie, onSelectMovie }) {
	return (
		<li onClick={() => onSelectMovie(movie.imdbID)}>
			<img src={movie.Poster} alt={`${movie.Title} poster`} />
			<h3>{movie.Title}</h3>
			<div>
				<p>
					<span>📅</span>
					<span>{movie.Year}</span>
				</p>
			</div>
		</li>
	)
}

function MovieDetails({ selectedId, onCloseMovie, onAddWatched, watched }) {

	const [movie, setMovie] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [userRating, setUserRating] = useState('')
	const watchedUserRating = watched.find(movie => movie.imdbID === selectedId)?.userRating;

	const isWatched = watched.map(movie => movie.imdbID).includes(selectedId)
	// console.log(isWatched)

	const { Title: title,
		Year: year,
		Poster: poster,
		Runtime: runtime,
		imdbRating,
		Plot: plot,
		Released: released,
		Actors: actors,
		Director: director,
		Genre: genre,
	} = movie

	function handleAdd() {
		const newWatchedMovie = {
			imdbID: selectedId,
			title,
			year,
			poster,
			imdbRating: Number(imdbRating),
			runtime: Number(runtime.split(" ").at(0)),
			userRating,
		};
		onAddWatched(newWatchedMovie)
		onCloseMovie()
	}


	useKey("Escape", onCloseMovie)



	useEffect(function () {
		async function getMovieDetails() {
			setIsLoading(true)
			const res = await fetch(`https://www.omdbapi.com/?apikey=${KEY}&i=${selectedId}`)
			const data = await res.json()
			setMovie(data)
			setIsLoading(false)
			// console.log(data)
		}
		getMovieDetails()
	}, [selectedId])


	useEffect(function () {
		if (!title) return;
		document.title = `Movie | ${title}`

		return function () {
			document.title = "usePopcorn"
			// console.log(`Clean up for the movie ${title}`)
		}

	}, [title])

	return <div className="details">
		{isLoading ? <Load /> :
			<>
				<header>
					<button className="btn-back" onClick={onCloseMovie}>&larr;</button>

					<img src={poster} alt={`Poster of ${title}`} />
					<div className="details-overview">
						<h2>{title}</h2>
						<p>
							{released} &bull; {runtime}
						</p>
						<p>{genre}</p>
						<p>
							<span>⭐</span>
							{imdbRating} IMDb rating
						</p>
					</div>
				</header >

				<section>
					<div className="rating">

						{
							!isWatched ?
								<>
									<StarRating
										maxRating={10}
										size={24}
										onSetRating={setUserRating} />
									{
										userRating > 0 && (
											<button
												className="btn-add"
												onClick={handleAdd}>
												+  Add to list
											</button>
										)
									}</> : <p>You rated movie with  {watchedUserRating}<span>⭐</span></p>}
					</div>
					<p><em>{plot}</em></p>
					<p>Starring {actors}</p>
					<p>Directed by{director}</p>
				</section>
			</>
		}



	</div >
}

function WatchedSummary({ watched }) {

	const avgImdbRating = average(watched.map((movie) => movie.imdbRating));
	const avgUserRating = average(watched.map((movie) => movie.userRating));
	const avgRuntime = average(watched.map((movie) => movie.runtime));

	return (
		<div className="summary">
			<h2>Movies you watched</h2>
			<div>
				<p>
					<span>#️⃣</span>
					<span>{watched.length} movies</span>
				</p>
				<p>
					<span>⭐️</span>
					<span>{avgImdbRating.toFixed(2)}</span>
				</p>
				<p>
					<span>🌟</span>
					<span>{avgUserRating.toFixed(2)}</span>
				</p>
				<p>
					<span>⏳</span>
					<span>{avgRuntime.toFixed(2)} min</span>
				</p>
			</div>
		</div>
	)
}

function WatchedMoviesList({ watched, onDeleteWatched }) {
	return (
		<ul className="list">
			{watched.map((movie) => (
				<WatchedMovie movie={movie} key={movie.imdbID} onDeleteWatched={onDeleteWatched} />
			))}
		</ul>
	)
}

function WatchedMovie({ movie, onDeleteWatched }) {
	return (
		<li >
			<img src={movie.poster} alt={`${movie.title} poster`} />
			<h3>{movie.title}</h3>
			<div>
				<p>
					<span>⭐️</span>
					<span>{movie.imdbRating}</span>
				</p>
				<p>
					<span>🌟</span>
					<span>{movie.userRating}</span>
				</p>
				<p>
					<span>⏳</span>
					<span>{movie.runtime} min</span>
				</p>

				<button className="btn-delete" onClick={() => onDeleteWatched(movie.imdbID)}>X</button>
			</div>
		</li>
	)
}